import { render, staticRenderFns } from "./byForm.vue?vue&type=template&id=35bb6b4a&scoped=true"
import script from "./byForm.vue?vue&type=script&lang=js"
export * from "./byForm.vue?vue&type=script&lang=js"
import style0 from "./byForm.vue?vue&type=style&index=0&id=35bb6b4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bb6b4a",
  null
  
)

export default component.exports